/* tslint:disable */

/**
 */
export class ModuleIdArray {
    modules?: number[];
}
